import { Injectable } from '@angular/core';

export interface UrlTelemetryContext {
  landingPageId: string;
  landingPageTypeId: string;
  thanksSubId: string;
  campaign: string;
  subId: string;
  offerId: string;
  offerThreadId: string;
  recordId: string;
  recordsForSMSReservedAutoID: string;
}

@Injectable({
  providedIn: 'root'
})
export class TelemetryContextService {
  getUrlTelemetryContext(urlParams: URLSearchParams): UrlTelemetryContext {
    const utmSourceContext = this.parseUtmSource(urlParams.get('utm_source'));

    return {
      landingPageId: this.getFirstValue(urlParams, ['landingPageID', 'landingPageId', 'landingpageID']) || 'default',
      landingPageTypeId: this.getFirstValue(urlParams, ['landingPageTypeID', 'landingPageTypeId']) || '',
      thanksSubId: this.getFirstValue(urlParams, ['ThanksSubID', 'thanksSubId']) || '',
      campaign: this.getFirstValue(urlParams, ['Campaign', 'campaign']) || '',
      subId: this.getFirstValue(urlParams, ['SubID', 'subId']) || '',
      offerId: this.normalizeId(utmSourceContext.offerId || this.getFirstValue(urlParams, ['OfferID', 'offerID', 'offerId'])),
      offerThreadId: this.normalizeId(utmSourceContext.offerThreadId || this.getFirstValue(urlParams, ['OfferThreadID', 'offerThreadID', 'offerThreadId', 'ThreadID', 'threadID', 'threadId'])),
      recordId: this.getFirstValue(urlParams, ['RecordID', 'recordID', 'recordId']) || '',
      recordsForSMSReservedAutoID: this.getFirstValue(urlParams, ['RecordsForSMSReservedAutoID', 'RecordsForSMSReservedID', 'recordsForSMSReservedAutoID']) || '',
    };
  }

  private parseUtmSource(value: string | null): { offerId: string; offerThreadId: string } {
    const parts = String(value || '').trim().split('_');
    if (parts.length < 3) {
      return { offerId: '', offerThreadId: '' };
    }

    return {
      offerId: parts[1] || '',
      offerThreadId: parts[2] || '',
    };
  }

  private getFirstValue(urlParams: URLSearchParams, keys: string[]): string {
    for (const key of keys) {
      const value = urlParams.get(key)?.trim();
      if (value) {
        return value;
      }
    }

    return '';
  }

  private normalizeId(value: string): string {
    const trimmed = String(value || '').trim();
    if (!/^\d+$/.test(trimmed)) {
      return '';
    }

    return trimmed.padStart(6, '0');
  }
}
